<template>
  <v-container class="main-container">
    <v-row>
      <v-col cols="12">
        <v-card flat class="mt-3 level-unlock-settings deposit-form create-account-form"
          :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'" elevation="0" tile>
          <v-card class="mb-5" :color="$vuetify.theme.dark ? '#172233' : '#f2f7fb'">
            <v-row>
              <v-col lg="12" md="12" sm="12" cols="12">
                <v-card-title class="mb-3 title">
                  What is Level Unlock ?
                </v-card-title>
                <v-card-subtitle class="sub-title">
                  Suppose Level 1 IB ‘A’ Has New Child X, Y & Z. All Of Childs
                  Deposited Amount in the Day 1 & Starts Trading.Within the
                  day 30, total trading lot of X+Y+Z = 50 Lots. Then The Day
                  31, Level 1 IB ‘A’ Will Go to Level 2 & His IB Commission
                  Will Increase 10%.
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="mb-5" :color="$vuetify.theme.dark ? '#172233' : '#f2f7fb'">
            <v-row>
              <v-col lg="12" md="12" sm="12" cols="12">
                <v-card-title class="mb-3 title">
                  Level 1 Commission
                </v-card-title>
                <v-card-subtitle class="sub-title">
                  Level 1 value will be partners IB Commission, Which You Have
                  Set From:
                  <router-link class="text--green" to="/commission-tree">Partners-Commission Setting</router-link>
                  . <br />In Next Level you Will Get Certain Percent Added
                  With IB Commission
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
          <v-card v-for="(levelData, index) in formattedSettings" :key="levelData.level" class="mb-5"
            :color="$vuetify.theme.dark ? '#172233' : '#f2f7fb'">
            <v-row>
              <v-col lg="12" md="12" sm="12" cols="12">
                <v-card-title class="mb-0 title">
                  <v-switch class="my-0" v-model="formData[index].status" inset color="#039de9" :ripple="false"
                    hide-details @change="handleSwitchChange(index)">
                    <template v-slot:label>
                      <div>
                        <span>Level {{ levelData.level }} Setting</span>
                      </div>
                    </template>
                  </v-switch>
                </v-card-title>
                <v-row v-if="formData[index].status" class="px-3 py-5">
                  <v-col cols="12" lg="6">
                    <fieldset class="mb-0">
                      <legend>
                        Level Up Bonus (% Increase On IB Commission)
                      </legend>
                      <v-text-field v-model="formData[index].level_up_bonus" label="e.g. 10" single-line solo
                        hide-details append-icon="mdi-percent-outline" class="custom-select ma-0 level-unlock-fieldset"
                        type="number" @input="validateInput(index, 'level_up_bonus')"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <fieldset class="mb-0">
                      <legend>
                        Min. Lots For This Level (By All Childs)
                      </legend>
                      <v-text-field v-model="formData[index].min_lots" label="e.g. 10" single-line solo suffix="Lots"
                        hide-details class="custom-select ma-0 level-unlock-fieldset" type="number"
                        @input="validateInput(index, 'min_lots')"></v-text-field>
                    </fieldset>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>

          <v-btn tile elevation="0" width="250" class="mt-8 text-capitalize btn-account mb-0 mx-0 px-10"
            color="greenMain" @click="handleUpdate" :loading="loading" :disabled="loading || $canRoute('level-unlock-settings-partner-tab') !== 1">
            Update
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LEVELUNLOCKSETTINGS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      loading: false,
      formData: {}
    };
  },

  computed: {
    ...mapState("levelunlock", ["partnersettings"]),
    ...mapState("admins", ["loggedAdmin"]),
    formattedSettings() {
      return this.partnersettings?.slice(0, 5) || [];
    },
  },

  methods: {
    ...mapActions("levelunlock", [
      LEVELUNLOCKSETTINGS__ACTIONS.PARTNERLEVELUNLOCKSETTINGS,
      LEVELUNLOCKSETTINGS__ACTIONS.POSTPARTNERLEVELUNLOCKSETTINGS,
    ]),

    initializeFormData() {
      if (this.partnersettings) {
        this.formData = this.partnersettings.reduce((acc, setting, index) => {
          acc[index] = {
            level: setting.level,
            level_up_bonus: setting.level_up_bonus || 0,
            min_lots: setting.min_lots || 0,
            status: setting.status === 1
          };
          return acc;
        }, {});
      }
    },

    validateInput(index, field) {
      let value = this.formData[index][field];
      if (typeof value === 'string') {
        value = parseFloat(value);
      }
      if (isNaN(value) || value < 0) {
        value = 0;
      }
      this.formData[index][field] = value;
    },

    handleSwitchChange(index) {
      if (!this.formData[index].status) {
        this.formData[index].level_up_bonus = 0;
        this.formData[index].min_lots = 0;
      }
    },

    async handleUpdate() {
      try {
        this.loading = true;
        const settings = Object.values(this.formData).map(item => ({
          level: item.level,
          level_up_bonus: parseFloat(item.level_up_bonus) || 0,
          min_lots: parseInt(item.min_lots) || 0,
          status: item.status ? 1 : 0
        }));

        await this[LEVELUNLOCKSETTINGS__ACTIONS.POSTPARTNERLEVELUNLOCKSETTINGS]({
          id: this.$route.query.id,
          settings
        });
      } catch (error) {
        console.error('Error updating settings:', error);
      } finally {
        this.loading = false;
      }
    }
  },

  watch: {
    partnersettings: {
      handler(newSettings) {
        if (newSettings) {
          this.initializeFormData();
        }
      },
      immediate: true
    }
  },

  async created() {
    await this[LEVELUNLOCKSETTINGS__ACTIONS.PARTNERLEVELUNLOCKSETTINGS](this.$route.query.id);
  }
};
</script>